import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { NgIconWrapperComponent } from '../../../components/icons/ng-icon-wrapper/ng-icon-wrapper.component';
import { TippyDirective } from '@ngneat/helipopper';

@Component({
    selector: 'app-settings-card',
    templateUrl: './settings-card.component.html',
    imports: [NgIconWrapperComponent, TippyDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettingsCardComponent {
  @Input()
  heading!: string;
  @Input()
  description!: string;
  @Input()
  disabled = false;
  @Input()
  showFooter = true;
  @Input()
  showSaveButton = true;

  @Output()
  save = new EventEmitter();

  isSaving = false;
  prepareSave() {
    setTimeout(() => (this.isSaving = true), 300);
    this.save.emit();
    setTimeout(() => (this.isSaving = false), 2000);
  }
}
